/**
 * aiInterviewApi.js — Service für das KI-Interview nach der Eintragung.
 * Muster analog digitalLeadVerificationApi.js.
 */
import axios from "axios";

// Erlaubte Werte — gespiegelt aus dem Backend (common/enum.js)
export const INTERVIEW_STATUS = {
  ACTIVE: "ACTIVE",
  COMPLETED: "COMPLETED",
  SKIPPED: "SKIPPED"
};

export const INTERVIEW_INPUT_MODE = {
  CHIP: "chip",
  VOICE: "voice",
  TEXT: "text"
};

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 60_000,
  headers: { "Content-Type": "application/json" }
});

export const startInterview = async (leadId) => {
  const { data } = await api.post("/ai-interview/start", {
    leadId,
    bootstrap: window.__aiInterviewBootstrap || undefined
  });
  return data.data;
};

export const answerInterview = async (leadId, answer, inputMode) => {
  const { data } = await api.post("/ai-interview/answer", {
    leadId,
    answer,
    inputMode
  });
  return data.data;
};

export const skipInterview = async (leadId) => {
  const { data } = await api.post("/ai-interview/skip", { leadId });
  return data.data;
};

// Serverseitige Transkription (Geräte ohne funktionierende Browser-
// Spracherkennung — iOS, In-App-Browser). Audio wird nur durchgereicht.
export const transcribeAudio = async (leadId, blob, filename) => {
  const form = new FormData();
  form.append("leadId", leadId);
  form.append("audio", blob, filename || "aufnahme.webm");
  const { data } = await api.post("/ai-interview/transcribe", form, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 120_000
  });
  return data.data;
};

// Diagnose: welche Eingabeart klappt, woran scheitert die Spracheingabe.
export const reportVoiceEvent = async (leadId, event, detail) => {
  try {
    await api.post("/ai-interview/voice-report", { leadId, event, detail });
  } catch (e) {
    /* Telemetrie darf den Nutzer nie stören */
  }
};

export const getInterviewState = async (leadId) => {
  const { data } = await api.get("/ai-interview/state", {
    params: { leadId }
  });
  return data.data;
};
